import React from 'react';
import { Button, Space } from 'antd';
import { statusTokens } from '../../../theme/theme';
import {
    showSuccessNotification,
    showErrorNotification,
    showWarningNotification,
    showInfoNotification
} from '../../../utils/notifications';

// Costanti dei colori
const SUCCESS = statusTokens.success;
const ERROR = statusTokens.error;
const WARNING = statusTokens.warning;
const INFO = statusTokens.info;

const MessageSection = () => {

    return (
        <Space
            size={16}
            wrap
            style={{
                display: 'flex',
                justifyContent: 'flex-start'
            }}
        >
            <Button
                type="primary"
                onClick={() => showSuccessNotification()}
                style={{
                    backgroundColor: SUCCESS,
                    borderColor: SUCCESS,
                    fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                    padding: 'clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 2vw, 1rem)',
                    height: 'auto',
                    minHeight: 'clamp(2rem, 5vw, 2.25rem)'
                }}
            >
                Show Success Message
            </Button>
            <Button
                type="primary"
                onClick={() => showErrorNotification()}
                style={{
                    backgroundColor: ERROR,
                    borderColor: ERROR,
                    fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                    padding: 'clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 2vw, 1rem)',
                    height: 'auto',
                    minHeight: 'clamp(2rem, 5vw, 2.25rem)'
                }}
            >
                Show Error Message
            </Button>
            <Button
                type="primary"
                onClick={() => showWarningNotification()}
                style={{
                    backgroundColor: WARNING,
                    borderColor: WARNING,
                    fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                    padding: 'clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 2vw, 1rem)',
                    height: 'auto',
                    minHeight: 'clamp(2rem, 5vw, 2.25rem)'
                }}
            >
                Show Warning Message
            </Button>
            <Button
                type="primary"
                onClick={() => showInfoNotification()}
                style={{
                    backgroundColor: INFO,
                    borderColor: INFO,
                    fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                    padding: 'clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 2vw, 1rem)',
                    height: 'auto',
                    minHeight: 'clamp(2rem, 5vw, 2.25rem)'
                }}
            >
                Show Info Message
            </Button>
            <Button
                onClick={() => showSuccessNotification('Custom Success', 'This is a custom success message!')}
                style={{
                    fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                    padding: 'clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 2vw, 1rem)',
                    height: 'auto',
                    minHeight: 'clamp(2rem, 5vw, 2.25rem)'
                }}
            >
                Custom Success
            </Button>
            <Button
                onClick={() => showErrorNotification('Custom Error', 'This is a custom error message!')}
                style={{
                    fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                    padding: 'clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 2vw, 1rem)',
                    height: 'auto',
                    minHeight: 'clamp(2rem, 5vw, 2.25rem)'
                }}
            >
                Custom Error
            </Button>
        </Space>
    );
};

export default MessageSection; 